import { WidgetCard } from '../WidgetCard';

export const ChartNumber = ({ data, ...props }) => {
  return (
    <WidgetCard {...props}>
      <div className="pt-7 pb-1 text-base-1000 text-[40px]/[100%] font-medium truncate">
        {data}
      </div>
    </WidgetCard>
  );
};
